import { useState } from "react";
import Nav from "../components/Nav";
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';

let themeRapifacDark = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#3bafda',
            light: '#8fd4ef',
            dark: '#0581b0',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#2b9bd8',
            contrastText: 'rgba(8,8,8,0.87)',
        },
        background: {
            default: '#182736',
            paper: '#1f2e3b',
        },
        text: {
            primary: 'rgba(255,255,255,0.75)',
            secondary: 'rgba(255,255,255,0.5)',
            disabled: 'rgba(255,255,255,0.25)',
            hint: 'rgba(255,255,255,0.25)',
        },
    },
    // components: {
    //     MuiCssBaseline: {
    //         styleOverrides: {
    //             body: {
    //                 scrollbarColor: "#6b6b6b #2b2b2b",
    //                 "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    //                     backgroundColor: "#b0b4b7",
    //                     width: '10px'
    //                 },
    //                 "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    //                     borderRadius: 8,
    //                     backgroundColor: "#6b6b6b",
    //                     minHeight: 24,
    //                 },
    //                 "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
    //                     backgroundColor: "#959595",
    //                 },
    //                 "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
    //                     backgroundColor: "#959595",
    //                 },
    //                 "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
    //                     backgroundColor: "#3e4a50",
    //                 },
    //                 "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
    //                     backgroundColor: "red",
    //                 },
    //             },
    //         },
    //     },
    // },
});
let themeRapifacLight = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#3bafda',
            light: '#8fd4ef',
            dark: '#0581b0',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#2b9bd8',
            contrastText: 'rgba(8,8,8,0.87)',
        },
        background: {
            default: 'white',
            paper: 'white',
        },
        text: {
            primary: 'black',
            secondary: 'black',
            disabled: 'black',
            hint: 'black',
        },
    },
    // components: {
    //     MuiCssBaseline: {
    //         styleOverrides: {
    //             body: {
    //                 scrollbarColor: "#6b6b6b #2b2b2b",
    //                 "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    //                     backgroundColor: "#b0b4b7",
    //                     width: '10px'
    //                 },
    //                 "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    //                     borderRadius: 8,
    //                     backgroundColor: "#6b6b6b",
    //                     minHeight: 24,
    //                 },
    //                 "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
    //                     backgroundColor: "#959595",
    //                 },
    //                 "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
    //                     backgroundColor: "#959595",
    //                 },
    //                 "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
    //                     backgroundColor: "#3e4a50",
    //                 },
    //                 "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
    //                     backgroundColor: "red",
    //                 },
    //             },
    //         },
    //     },
    // },
});

const Layout = ({ children }) => {
    const [actualTheme, setActualTheme] = useState(themeRapifacLight);
    const handleChangeThemeRapifac = (event) => {
        if (event) setActualTheme(themeRapifacDark)
        else setActualTheme(themeRapifacLight)
    }
    return (
        <>
            <ThemeProvider theme={actualTheme}>
                <Nav onChangeThemeRapifac={handleChangeThemeRapifac} />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        pt: 3,
                        width: { md: `calc(100% - 15rem)` },
                        marginLeft: { md: `15rem` },
                        paddingLeft: { xs: 10, md: 15, xl: 10},
                        paddingRight: { md: 12, xl: 15 },
                        mt: 6
                    }}
                >
                    {children}
                </Box>
            </ThemeProvider>
        </>
    )
}
export default Layout;